import { isDefined } from "@clipboard-health/util-ts";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { roundUpRateToNearestCentUsingCbhRounding } from "@src/appV2/Shifts/utils/payRateCalculation";
import { roundUpHoursToTwoDecimalsUsingCbhRounding } from "@src/appV2/Shifts/utils/timeCalculation";

import { type ModalShiftData } from "../Shift/types";

export interface PayCalculationResult {
  payAmount: number;
  formattedPayAmount: string;
}
export function calculateTotalPay(params: {
  hourlyPayRate: number;
  hoursWorked: number;
}): PayCalculationResult {
  const { hourlyPayRate, hoursWorked } = params;
  const roundedHoursWorked = roundUpHoursToTwoDecimalsUsingCbhRounding(hoursWorked);
  const payAmount = roundUpRateToNearestCentUsingCbhRounding(hourlyPayRate * roundedHoursWorked);
  const formattedPayAmount = formatDollarsAsUsd(payAmount);

  return {
    payAmount,
    formattedPayAmount,
  };
}

export function calculateBreakPay(params: {
  hourlyRate: number;
  breakTimeInHours: number;
}): PayCalculationResult {
  const { hourlyRate, breakTimeInHours } = params;
  return calculateTotalPay({
    hourlyPayRate: hourlyRate,
    hoursWorked: breakTimeInHours,
  });
}

export function getShiftPayRates(parameters: {
  shift: ModalShiftData;
  rateNegotiationId?: string;
}): {
  hourlyPay: number;
  totalPay: number;
  totalPayFormatted: string;
  hourlyPayFormatted: string;
} {
  const { shift, rateNegotiationId } = parameters;

  const rateNegotiation = isDefined(rateNegotiationId) ? shift.rateNegotiation : undefined;

  if (isDefined(rateNegotiation?.lastOffer)) {
    return {
      hourlyPay: rateNegotiation.lastOffer.hourlyPay,
      totalPay: rateNegotiation.lastOffer.totalPay,
      totalPayFormatted: rateNegotiation.lastOffer.formattedTotalPay,
      hourlyPayFormatted: rateNegotiation.lastOffer.formattedHourlyPay,
    };
  }

  if (isDefined(shift.offer)) {
    return {
      hourlyPay: shift.offer.attributes.hourlyPay,
      totalPay: shift.offer.attributes.totalPay,
      totalPayFormatted: shift.offer.attributes.formattedTotalPay,
      hourlyPayFormatted: shift.offer.attributes.formattedHourlyPay,
    };
  }

  return {
    hourlyPay: 0,
    totalPay: 0,
    totalPayFormatted: formatDollarsAsUsd(0),
    hourlyPayFormatted: formatDollarsAsUsd(0),
  };
}
